module.exports = __webpack_public_path__ + "img/fy.5a34c3eb.svg";